export class Me {
  static readonly type = '[User] Get';

  constructor() {}
}

export class ClearMe {
  static readonly type = '[User] Clear';

  constructor() {}
}
